<template>
  <div>
    <section class="bill" :class="'bill--' + $route.params.code.toLowerCase()">
      <div class="container">
        <div class="row" v-if="$store.state.showBack">
          <div class="col-lg-12 pt-4">
            <back :before="beforeBack" />
          </div>
        </div>
        <div class="row bill-header">
          <div class="col-lg-8">
            <tab-header :list="this.active ? [$t('bill.titleSuppy'),$t('bill.bills'), $t('bill.manage')] : [$t('bill.titleSuppy'),$t('bill.bills'), $t('bill.view')]" :active-index="activeIndex" @select="(index) => activeIndex = index" />
          </div>
          <!-- <div class="col-lg-4 bill-header-code">
            <div>
              {{ $t("bill.supply") }} {{ $route.params.code.toLowerCase() === 'ee' ? $t("bill.supplyEE") : $t("bill.supplyGas") }}{{ this.active ? $t("bill.active") : $t("bill.not_active") }}       
            </div>
            <div>
              <strong>{{ supplyPoint }}</strong>
            </div>
          </div> -->
        </div>
        <div class="row bill-resume" v-if="activeIndex == 0">
          <div class="col-md-12 col-lg-4">
            <div class="d-flex align-items-center">
              <div class="bill-resume-head">
                <div style="align-items: flex-start;" class="d-flex bill-resume-head-content">
                  <img :src="supplyIcon">
                  <div>
                    <div class="bill-resume-head-content-title" style="display: flex; flex-direction: row;">
                      <div style="width: 20px;height:100%;margin-right: 4px;align-items:center;justify-items: center;">
                          <div v-if="this.active" style="background-color: #54863f;width: 20px;height: 20px;border-radius: 10px;">
                          </div> 
                          <div v-if="!this.active" style="background-color:red;width: 20px;height: 20px;border-radius: 10px;">
                          </div>   
                      </div>  
                      <b>{{ $t("bill.supply") }} {{ $route.params.code.toLowerCase() === 'ee' ? $t("bill.supplyEE") : $t("bill.supplyGas") }}{{ this.active ? $t("bill.active") : '' }}</b>
                    </div>
                    <div style="margin-top: 20px;color: #002626;opacity: .5;font-weight: bold;" class="bill-resume-head-content-infoinvoice">{{ $route.params.code.toLowerCase() === 'ee' ? 'POD' : 'PDR'}}</div>
                    <div class="bill-resume-head-content-infoinvoice">{{supplyPoint }}</div>
                     <div style="margin-top: 10px;color: #002626;opacity: .5;font-weight: bold;" v-if="$store.state.supply.address != null" class="bill-resume-head-content-infoinvoice">{{ $t("bill.invoiceAddress")}}</div>
                    <div v-if="$store.state.supply.address != null" class="bill-resume-head-content-infoinvoice">{{ $store.state.supply.address}}</div>
                      <div style="margin-top: 10px;color: #002626;opacity: .5;font-weight: bold;" v-if="$store.state.supply.address != null" class="bill-resume-head-content-infoinvoice">{{ $t("bill.invoiceCustomerName")}}</div>
                    <div v-if="$store.state.currentUserContract.user.customerName != null" class="bill-resume-head-content-infoinvoice">{{ $store.state.currentUserContract.user.customerName}}</div>
                     <div style="margin-top: 10px;color: #002626;opacity: .5;font-weight: bold;" v-if="$store.state.supply.address != null" class="bill-resume-head-content-infoinvoice">{{ $t("bill.invoiceFiscalCode")}}</div>
                    <div class="bill-resume-head-content-infoinvoice">{{ $store.state.supply.vat != null && $store.state.supply.vat.length > 0 ? $store.state.supply.vat : ($store.state.supply.fiscalCode != null && $store.state.supply.fiscalCode.length > 0 ? $store.state.supply.fiscalCode : ''  )}}</div>
                    
                  </div>
                </div>
                <!-- <div class="col-lg-12 bill-history" style="margin-top: 60px;" v-if="this.$store.state.dashboard && !this.$store.state.dashboard.consumptionStatsVisible && $store.state.showHistory">
                  <c-link @click="goToBills">{{ $t("bill.showHistory") }}</c-link>
                </div> -->
              </div>
            </div>
          </div>
           <div class="col-md-6 col-lg-4" v-if="supplyHome == undefined || supplyHome == null">

           </div>
          <div class="col-md-6 col-lg-4" v-if="supplyHome != undefined && supplyHome != null">
            <div class="d-flex align-items-center">
              <div class="is-mobile" style="height: 5px;"></div>
              <div class="bill-price" v-if="supplyHome != undefined && supplyHome != null">
                <div style="margin-top: 0px;color: #002626;opacity: .5;font-weight: bold;" v-if="supplyHome != undefined && supplyHome != null && supplyHome.invoiceNumber != null" class="bill-resume-head-content-infoinvoice">{{ $t("bill.lastInvoice")}}</div>
                <div style="margin-top: 13px;color: #002626;opacity: .5;font-weight: bold;" v-if="supplyHome != undefined && supplyHome != null && supplyHome.invoiceNumber != null" class="bill-resume-head-content-infoinvoice">{{ $t("bill.invoiceTitle")}}</div>
                <div v-if="supplyHome != undefined && supplyHome != null && supplyHome.invoiceNumber != null" class="bill-resume-head-content-infoinvoice">{{supplyHome.invoiceNumber }}</div>
                
                <div style="margin-top: 10px;color: #002626;opacity: .5;font-weight: bold;" v-if="supplyHome != undefined && supplyHome != null && supplyHome.totalValue != null" class="small-text">{{ $t("bill.titlePrice")}}</div>
                <div v-if="supplyHome != undefined && supplyHome != null && supplyHome.totalValue != null" class="bill-resume-head-content-infoinvoice">{{ formatFloat(supplyHome.totalValue) }} €</div>
               

                <div style="margin-top: 10px;color: #002626;opacity: .5;font-weight: bold;" v-if="supplyHome != undefined && supplyHome != null && supplyHome.expirationDate != null && supplyHome.expirationDate.length > 0" class="small-text">{{ $t("bill.invoiceExpiried")}}</div>
                <div v-if="supplyHome != undefined && supplyHome != null && supplyHome.expirationDate != null && supplyHome.expirationDate.length > 0" class="bill-resume-head-content-infoinvoice">{{ $moment(supplyHome.expirationDate).format('DD/MM/YYYY') }}</div>
                
                <div style="margin-top: 10px;color: #002626;opacity: .5;font-weight: bold;" v-if="supplyHome != undefined && supplyHome != null && supplyHome.competenceDate != null && supplyHome.competenceDate.length > 0" class="small-text">{{ $t("bill.invoicePeriod")}}</div>
                 <div v-if="supplyHome != undefined && supplyHome != null && supplyHome.competenceDate != null && supplyHome.competenceDate.length > 0" class="bill-resume-head-content-infoinvoice">{{ supplyHome.competenceDate }}</div>
                   
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 text-md-end">
            <!-- activeIndex == 0-->
             <a style="width: 250px;text-align: center;color: red; border-width: 2px; border-color: red;"  v-if="this.activeIndex == 0 && paymentStatus == 'ko'"
              @click="this.goToBillsKO" target="_blank" class="bill-resume-download">
              {{ $t("bill.buttonInvoiceTitleKO") }}
            </a>
            <div v-if="this.activeIndex == 0 && paymentStatus == 'ko'"  style="width: 15px;height: 5px;"></div>
          
              <a  style="width: 250px;height: 50px;align-items: center;justify-items: center;"  v-if="this.activeIndex == 0 && supplyHome.pdfURL != supplyHome.syntheticPdfURL" @click="() => this.$store.commit('showInvoiceMenu',true)" class="bill-resume-download">
                <div style="display: flex;align-items: center;justify-items: center">
                     <img :src="icoDownload">
                    {{ $t("bill.lastInvoice") }}
                     
                </div>  
               
              </a>
              <div v-if="this.activeIndex == 0 && supplyHome.pdfURL == supplyHome.syntheticPdfURL"  style="width: 15px;height: 5px;"></div>
              <a style="width: 250px;height: 50px;align-items: center;justify-items: center;" v-if="this.activeIndex == 0 && supplyHome.pdfURL == supplyHome.syntheticPdfURL" :href="supplyHome.pdfURL" target="_blank" class="bill-resume-download">
                <div style="display: flex;align-items: center;justify-items: center">
                   <img :src="icoDownload"> 
                   {{ $t("bill.lastInvoice") }}
                </div>  
              </a>
            
            <!-- activeIndex == 0-->
           <div v-if="this.activeIndex == 0"  style="width: 15px;height: 5px;"></div>
           <a style="width: 250px;text-align: center;"  v-if="this.activeIndex == 0" 
              @click="this.goToBills" target="_blank" class="bill-resume-download">
              {{ $t("bill.buttonTitleHistory") }}
            </a>
            <div v-if="this.$store.state.supply.paymentButtonVisible  && this.activeIndex == 1"  style="width: 15px;height: 5px;"></div>
             <a v-bind:style="[this.$store.state.supply.paymentButtonEnabled  && this.activeIndex == 1 ? 
            {'width': '250px','text-align': 'center'} : 
            {'width': '250px','text-align': 'center','pointer-events':'none','cursor':'default','color':'gray','border-color':'gray'}]" 
            v-if="this.$store.state.supply.paymentButtonVisible  && this.activeIndex == 1" 
            @click="this.payNow" target="_blank" class="bill-resume-download">
             {{ this.$store.state.supply.paymentButtonLabel }}
            </a>
          </div>
        </div>
        <div class="row bill-resume" v-if="activeIndex == 1">
          <div class="col-md-12 col-lg-4">
            <div class="d-flex align-items-center">
              <div class="bill-resume-head">
                <div style="align-items: flex-start;" class="d-flex bill-resume-head-content">
                  <img :src="supplyIcon">
                  <div>
                     <div v-if="$store.state.supply.totalValue != null" class="bill-price-total">
                        {{ formatFloat($store.state.supply.totalValue) }}
                        <span>€</span>
                      </div>
                      <div style="margin-top: 20px;color: #002626;opacity: .5;font-weight: bold;" v-if="$store.state.supply.invoiceNumber != null" class="bill-resume-head-content-infoinvoice">{{ $t("bill.invoiceTitle")}}</div>
                      <div v-if="$store.state.supply.invoiceNumber != null" class="bill-resume-head-content-infoinvoice">{{$store.state.supply.invoiceNumber }}</div>
                          
                      <div style="margin-top: 10px;color: #002626;opacity: .5;font-weight: bold;" v-if="$store.state.supply.expirationDate != null && $store.state.supply.expirationDate.length > 0" class="small-text">{{ $t("bill.invoiceExpiried")}}</div>
                      <div v-if="$store.state.supply.expirationDate != null && $store.state.supply.expirationDate.length > 0" class="bill-resume-head-content-infoinvoice">{{ $moment($store.state.supply.expirationDate).format('DD/MM/YYYY') }}</div>
                      
                      <div style="margin-top: 10px;color: #002626;opacity: .5;font-weight: bold;" v-if="$store.state.supply.competenceDate != null && $store.state.supply.competenceDate.length > 0" class="small-text">{{ $t("bill.invoicePeriod")}}</div>
                      <div v-if="$store.state.supply.competenceDate != null && $store.state.supply.competenceDate.length > 0" class="bill-resume-head-content-infoinvoice">{{ $store.state.supply.competenceDate }}</div>
                
                  </div>
                </div>
                <div class="col-lg-12 bill-history" style="margin-top: 60px;" v-if="this.$store.state.dashboard && !this.$store.state.dashboard.consumptionStatsVisible && $store.state.showHistory">
                  <c-link @click="goToBills">{{ $t("bill.showHistory") }}</c-link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="d-flex align-items-center">
              <div class="bill-price">
                <div class="bill-resume-head-content-title" style="display: flex; flex-direction: row;">
                      
                      <div style="width: 20px;height:100%;margin-right: 4px;align-items:center;justify-items: center;">
                          <div v-if="this.active" style="background-color: #54863f;width: 20px;height: 20px;border-radius: 10px;">
                          </div> 
                          <div v-if="!this.active" style="background-color:red;width: 20px;height: 20px;border-radius: 10px;">
                          </div>   
                      </div>  
                      <b>{{ $t("bill.supply") }} {{ $route.params.code.toLowerCase() === 'ee' ? $t("bill.supplyEE") : $t("bill.supplyGas") }}{{ this.active ? $t("bill.active") : '' }}</b>
                    </div>
                    <div style="display: flex;flex-direction: row;margin-top: 10px;">
                      <div style="margin-top: 0px;color: #002626;opacity: .5;font-weight: bold;margin-right: 4px;" class="bill-resume-head-content-infoinvoice">{{ $route.params.code.toLowerCase() === 'ee' ? 'POD' : 'PDR'}}:</div>
                      <div class="bill-resume-head-content-infoinvoice">{{supplyPoint }}</div>
                    </div>
                    <div style="margin-top: 5px;" v-if="$store.state.supply.address != null" class="bill-resume-head-content-infoinvoice">{{ $store.state.supply.address}}</div>                   
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 text-md-end">
            
            
            <a style="width: 250px;height: 50px;align-items: center;justify-items: center;"  v-if="this.$store.state.supply.pdfURL != this.$store.state.supply.syntheticPdfURL" @click="() => this.$store.commit('showInvoiceMenu',true)" class="bill-resume-download">
                  <div style="display: flex;align-items: center;justify-items: center;">
                    <img :src="icoDownload"> 
                    {{ $t("bill.download") }}
                  </div>
                  
            </a>
             <div v-if="this.activeIndex == 1 && supplyHome.pdfURL == supplyHome.syntheticPdfURL"  style="width: 15px;height: 5px;"></div>
            <a style="width: 250px;height: 50px;align-items: center;justify-items: center;" v-if="this.$store.state.supply.pdfURL == this.$store.state.supply.syntheticPdfURL" :href="this.$store.state.supply.pdfURL" target="_blank" class="bill-resume-download">
                 <div style="display: flex;align-items: center;justify-items: center;">
                    <img :src="icoDownload"> 
                    {{ $t("bill.download") }}
                  </div>
            </a>
            <div v-if="this.$store.state.supply.paymentButtonVisible && this.activeIndex == 1"  style="width: 15px;height: 5px;"></div>
            <a v-bind:style="[this.$store.state.supply.paymentButtonEnabled  && this.activeIndex == 1 ? 
            {'width': '250px','text-align': 'center'} : 
            {'width': '250px','text-align': 'center','pointer-events':'none','cursor':'default','color':'gray','border-color':'gray'}]" 
            v-if="this.$store.state.supply.paymentButtonVisible  && this.activeIndex == 1" 
            @click="this.payNow" target="_blank" class="bill-resume-download">
             {{ this.$store.state.supply.paymentButtonLabel }}
            </a>
          </div>
        </div>
        <div class="row bill-data" v-if="this.$store.state.dashboard && this.$store.state.dashboard.consumptionStatsVisible && activeIndex != 2">
          <!-- <div class="col-lg-4 col-md-6 mb-4" v-if="consumption.hasOwnProperty('monthConsumption') && consumption.monthConsumption">
            <div class="d-flex justify-content-between">
              <div class="bill-data-details">
                <div class="bill-data-details-title">{{ $t("bill.consumption") }}</div>
                <div class="bill-data-details-number">
                  {{ consumption.monthConsumption ?  Math.round(consumption.monthConsumption) : 0 }}
                  <span v-if="$route.params.code.toLowerCase() === 'ee'">kWh</span>
                  <span v-if="$route.params.code.toLowerCase() === 'gas'">smc</span>
                </div>
              </div>
              <div class="bill-data-desc">
                <div>
                  <div style="display: flex;flex: 1;flex-direction: row;align-items: center;justify-content: center;" class="bill-data-desc-indicator" :class="[ consumption.monthConsumptionPreviousYearPercentageDifference > 0 ? 'bill-data-desc-indicator--red' : (consumption.monthConsumptionPreviousYearPercentageDifference < 0 ? 'bill-data-desc-indicator': 'bill-data-desc-indicator--white') ]">{{ consumption.monthConsumptionPreviousYearPercentageDifference ? (consumption.monthConsumptionPreviousYearPercentageDifference > 0 ? '+'+ Math.round(consumption.monthConsumptionPreviousYearPercentageDifference) :  Math.round(consumption.monthConsumptionPreviousYearPercentageDifference)) : 0 }}%</div>
                  <div class="bill-data-desc-text">{{ $t("bill.consumptionDesc") }}</div>
                </div>
              </div>
            </div>
          </div> -->
          <BarChart 
               v-if="labels.length > 0"
               :type="$route.params.code.toLowerCase()"
               :labels="labels"
               :values="values"
               :f1Values="f1Values"
               :f2Values="f2Values"
               :f3Values="f3Values"
               :chartTitle="$route.params.code.toLowerCase() === 'ee' ? $t('bill.consumption_ee') : $t('bill.consumption_gas')"
            />
          <!-- <div class="col-lg-4 col-md-6 mb-4" v-if="consumption.hasOwnProperty('averageThreeMonthsConsumption') && consumption.averageThreeMonthsConsumption">
            <div class="d-flex justify-content-between">
              <div class="bill-data-details">
                <div class="bill-data-details-title">{{ $t("bill.consumptionAverage") }}</div>
                <div class="bill-data-details-number">
                  {{ consumption.averageThreeMonthsConsumption ? consumption.averageThreeMonthsConsumption : 0 }}
                  <span v-if="$route.params.code.toLowerCase() === 'ee'">kWh</span>
                  <span v-if="$route.params.code.toLowerCase() === 'gas'">smc</span>
                </div>
              </div>
              <div class="bill-data-desc">
                <div>
                  <div class="bill-data-desc-indicator" :class="{ 'bill-data-desc-indicator--red': consumption.averageThreeMonthsConsumptionPreviousYearPercentageDifference >= 0 }">{{ consumption.averageThreeMonthsConsumptionPreviousYearPercentageDifference ? (consumption.averageThreeMonthsConsumptionPreviousYearPercentageDifference > 0 ? '+'+consumption.averageThreeMonthsConsumptionPreviousYearPercentageDifference : consumption.averageThreeMonthsConsumptionPreviousYearPercentageDifference) : 0 }}%</div>
                  <div class="bill-data-desc-text">{{ $t("bill.consumptionDesc") }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-4" v-if="consumption.hasOwnProperty('monthPeak') && consumption.monthPeak">
            <div class="d-flex justify-content-between">
              <div class="bill-data-details">
                <div class="bill-data-details-title">{{ $t("bill.consumptionPeak") }}</div>
                <div class="bill-data-details-number">
                  {{ consumption.monthPeak ? consumption.monthPeak : 0 }} <span>kW</span>
                </div>
              </div>
              <div class="bill-data-desc">
                <div>
                  <div class="bill-data-desc-text">{{ $t("bill.consumptionMessage") }}</div>
                </div>
              </div>
            </div>
          </div> -->
          <div v-if="!$store.state.showHistory" style="height: 60px;"></div>
          <div class="col-lg-12 bill-history" v-if="$store.state.showHistory">
            <c-link @click="goToBills">{{ $t("bill.showHistory") }}</c-link>
          </div>
        </div>
      </div>
    </section>
    <section v-if="activeIndex != 2 && events.length" class="overflow-hidden">
      <div class="container">
        <div class="row bill-events">
          <div class="col-lg-12">
            <h3 class="bill-events-title">{{ $t("bill.eventsTitle") }}</h3>

            <swiper
              style="overflow:visible"
              :slides-per-view="1"
              :modules="modules"
              :breakpoints="breakpoints"
              :scrollbar="{ draggable: true }"
              @reachEnd="loadMore"
            >
              <template v-for="(e,i) in events" :key="'event-'+i">
                <swiper-slide>
                  <history-event :event="e"/>
                </swiper-slide>
              </template>
            </swiper>

          </div>
        </div>
      </div>
    </section>

    <section v-if="activeIndex == 2" class="manage" :class="'manage--' + $route.params.code.toLowerCase()">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h3 class="manage-title">{{ $t("bill.contract") }}</h3>
          </div>
          <div class="col-md-4 mb-4">
            <div class="manage-block">
              <h3 class="manage-block-title">{{ $t("bill.paymentType") }}</h3>
              <div class="manage-block-bank">
                <img :src="icoBank">
                <div>
                  <div class="manage-block-bank-title">{{ this.getMethodPayment() == "RID" ? $t("bill.paymentTypeBank") : $t("bill.paymentTypeBLP") }}</div>
                  <div class="manage-block-bank-label">{{ this.getMethodPayment() == "RID" ? this.getBankName() : '' }}</div>
                </div>
              </div>
              <c-link v-if="this.active" @click="() => goToHelp(1)">{{ $t("bill.contact") }}</c-link>
            </div>
          </div>

          <div class="col-md-4 mb-4" v-if="this.active">
            <div class="manage-block">
              <h3 class="manage-block-title">{{ $t("bill.voltureTitle") }}</h3>
              <div class="manage-block-text">{{ $t("bill.voltureDesc") }}</div>
              <c-link @click="() => goToHelp(2)">{{ $t("bill.contact") }}</c-link>
            </div>
          </div>

          <div class="col-md-4 mb-4" v-if="this.active">
            <div class="manage-block">
              <h3 class="manage-block-title">{{ $t("bill.addressTitle") }}</h3>
              <div class="manage-block-text">{{ $t("bill.addressDesc") }}</div>
              <c-link @click="() => goToHelp(7)">{{ $t("bill.contact") }}</c-link>
            </div>
          </div>

          <div class="col-lg-12">
            <h3 class="manage-title">{{ $t("bill.counter") }}</h3>
          </div>
          <div class="col-md-12 mb-4">
            <div class="manage-block-counter">
              <div class="manage-block-counter-title">
                <img :src="icoCounter"> {{ $t("bill.yourCounter") }}
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div v-if="$route.params.code.toLowerCase() === 'ee'" class="manage-block-counter-subtitle">{{ $t("bill.pod") }}</div>
                  <div v-if="$route.params.code.toLowerCase() === 'gas'" class="manage-block-counter-subtitle">{{ $t("bill.pdr") }}</div>
                  <div class="manage-block-counter-text">{{ supplyPoint }}</div>
                </div>
                <div class="col-md-4">
                  <div class="manage-block-counter-subtitle">{{ $t("bill.fiscalCode") }}</div>
                  <div class="manage-block-counter-text">{{ $store.state.supply.fiscalCode }}</div>
                </div>
                <div class="col-md-4">
                  <div class="manage-block-counter-subtitle">{{ $t("bill.address") }}</div>
                  <div class="manage-block-counter-text">{{ $store.state.supply.address }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-4" v-if="this.active">
            <div class="manage-block">
              <h3 class="manage-block-title">{{ $t("bill.verifyTitle") }}</h3>
              <div class="manage-block-text">{{ $t("bill.verifyDesc") }}</div>
              <c-link @click="() => goToHelp(3)">{{ $t("bill.contact") }}</c-link>
            </div>
          </div>

          <div class="col-md-4 mb-4" v-if="this.active">
            <div class="manage-block">
              <h3 class="manage-block-title">{{ $t("bill.powerTitle") }}</h3>
              <div class="manage-block-text">{{ $t("bill.powerDesc") }}</div>
              <c-link @click="() => goToHelp(4)">{{ $t("bill.contact") }}</c-link>
            </div>
          </div>

          <div class="col-md-4 mb-4" v-if="this.active">
            <div class="manage-block">
              <h3 class="manage-block-title">{{ $t("bill.moveTitle") }}</h3>
              <div class="manage-block-text">{{ $t("bill.moveDesc") }}</div>
              <c-link @click="() => goToHelp(5)">{{ $t("bill.contact") }}</c-link>
            </div>
          </div>

          <div class="col-md-4 mb-4" v-if="this.active">
            <div class="manage-block">
              <h3 class="manage-block-title">{{ $t("bill.removeTitle") }}</h3>
              <div class="manage-block-text">{{ $t("bill.removeDesc") }}</div>
              <c-link @click="() => goToHelp(6)">{{ $t("bill.contact") }}</c-link>
            </div>
          </div>
          <div style="height: 80px;" v-if="!this.active && this.windowWidth >= 480">
          </div>
        </div>
      </div>
    </section>
    <popup :urlPdf="this.$store.state.supply.pdfURL" :urlSmallPdf="this.$store.state.supply.syntheticPdfURL" :code="$route.params.code" @close="this.$store.state.showMenuInvoice = false" v-if="this.$store.state.showMenuInvoice  && this.activeIndex == 1">
      <div>
         
         
        </div>
    </popup>
    <PopupHome :urlPdf="supplyHome.pdfURL" :urlSmallPdf="supplyHome.syntheticPdfURL" :code="$route.params.code" @close="this.$store.state.showMenuInvoice = false" v-if="this.$store.state.showMenuInvoice && this.activeIndex == 0">
    </PopupHome>
  </div>
</template>

<script>
import TabHeader from "@/components/TabHeader";
import icoDownloadEE from '../assets/ico-download-ee.svg'
import icoDownloadGAS from '../assets/ico-download-gas.svg'
import ee from '../assets/ee.png'
import gas from '../assets/gas.png'
import icoBank from '../assets/ico-bank.svg'
import icoCounter from '../assets/ico-contatore.svg'
import CLink from "@/components/CLink";
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import { FreeMode } from "swiper";
import "swiper/swiper.min.css";
import 'swiper/modules/scrollbar/scrollbar.min.css';
import "swiper/modules/free-mode/free-mode.min.css"
import HistoryEvent from "@/components/HistoryEvent";
import Back from "@/components/Back";
import Popup from "@/components/PopupInvoiceMenu";
import PopupHome from "@/components/PopupInvoiceMenu";
import BarChart from "@/components/BarChart";
export default {
  name: 'Bill',
  components: {
    Back,
    BarChart,
    HistoryEvent,
    CLink,
    TabHeader,
    Swiper,
    SwiperSlide,
    Popup,
    PopupHome
  },
  data: function () {
    let supplyPoint = this.$store.state.supply.supplyPoint;
    var supplyHome = undefined;

    console.log(supplyHome);

    if (this.$store.state.supply.SupplyPoint) {
      supplyPoint = this.$store.state.supply.SupplyPoint
    }

    for (let index = 0; index < this.$store.state.supplyPoints.length; index++) {
      const element = this.$store.state.supplyPoints[index];

      console.log(element.supplyPoint,'_aa_xx_1');
      console.log(supplyPoint,'_aa_xx_2');
      
      if (element.supplyPoint === supplyPoint) {
        supplyHome = element;
        break;
      }
    }

    let active = this.isActive();

    return {
      windowWidth: window.innerWidth,
      paymentStatus: 'ok',
      activeIndex: 0,
      icoBank: icoBank,
      icoCounter: icoCounter,
      icoDownload: this.$route.params.code.toLowerCase() === 'ee' ? icoDownloadEE : icoDownloadGAS,
      supplyIcon: this.$route.params.code.toLowerCase() === 'ee' ? ee : gas,
      consumption: {},
      events: [],
      modules: [FreeMode, Scrollbar],
      supplyPoint: supplyPoint,
      limit: 5,
      offset: 0,
      end: false,
      active:active,
      labels:[],
      values:[],
      f1Values:[],
      f2Values:[],
      f3Values:[],
      breakpoints: {
        1200: {
          slidesPerView: 4
        },
        1025: {
          slidesPerView: 3
        },
        768: {
          slidesPerView: 2
        }
      },
      supplyHome: (supplyHome == undefined || supplyHome == null) ? undefined : supplyHome 
    }
  },
  methods: {
    payNow: function() {

      this.to = setInterval(async() => {
        await this.axios.get(process.env.VUE_APP_API_DWH_URL + 'invoices?invoiceId=' + this.$store.state.supply.invoiceId + '&limit=1&offset=0', this.authDWHSetting)
        .then((response) => {

          if (response != null && response != undefined) {
            const data = response.data;

            if (data != null && data != undefined) {
                const invoices =  data.invoices;
                if (invoices != null && invoices != undefined && Array.isArray(invoices) && invoices.length > 0) {
                  const invoice = invoices[0];

                  if (invoice.paymentStatus == "PAID" || invoice.paymentStatus == "INPAYMENT") {
                    this.$store.commit('setSupply', invoice);
                    clearInterval(this.to);
                    this.to = undefined;
                  }
                } else {
                  clearInterval(this.to);
                  this.to = undefined;
                }
            } else {
              clearInterval(this.to);
              this.to = undefined;
            }
          } else {
            clearInterval(this.to);
            this.to = undefined;
          }
        }).catch((e) => {
          console.log(e,'_aa_xx_error');
          clearInterval(this.to);
          this.to = undefined;
        });

        console.log('_aa_xx_calling_end');
      }, 1000);
      window.open(this.$store.state.supply.paymentURL, '_blank');
    },
    isActive: function() {
      var active = false;

      const userContract = this.$store.state.currentUserContract;
      const supply = this.$store.state.supply;

      const supplies = userContract.supplyPoints;

      for (let index = 0; index < supplies.length; index++) {
        const element = supplies[index];

      
        if (supply.supplyPoint != undefined && supply.supplyPoint != null) {
          if (element.supplyPoint == supply.supplyPoint) {
            active = element.active;
            break;
          }
        } else if (supply.SupplyPoint != undefined && supply.SupplyPoint != null) {
          if (element.supplyPoint == supply.SupplyPoint) {
            active = element.active;
            break;
          }
        }

       

      }
      
      return active;
    },
    getBankName: function() {
      var bankName = "";

      const userContract = this.$store.state.currentUserContract;
      const supply = this.$store.state.supply;

      const supplies = userContract.supplyPoints;

      for (let index = 0; index < supplies.length; index++) {
        const element = supplies[index];

        if (supply.supplyPoint != undefined && supply.supplyPoint != null) {
          if (element.supplyPoint == supply.supplyPoint) {
            bankName = element.bankName;
            break;
          }
        } else if (supply.SupplyPoint != undefined && supply.SupplyPoint != null) {
          if (element.supplyPoint == supply.SupplyPoint) {
            bankName = element.bankName;
            break;
          }
        }

      }
      
      return bankName;
    },
    getMethodPayment: function() {
      var payment = "RID";

      const userContract = this.$store.state.currentUserContract;
      const supply = this.$store.state.supply;

      const supplies = userContract.supplyPoints;

      for (let index = 0; index < supplies.length; index++) {
        const element = supplies[index];

        if (supply.supplyPoint != undefined && supply.supplyPoint != null) {
          if (element.supplyPoint == supply.supplyPoint) {
            payment = element.masterContractPaymentTypeCode;
            break;
          }
        } else if (supply.SupplyPoint != undefined && supply.SupplyPoint != null) {
          if (element.supplyPoint == supply.SupplyPoint) {
            payment = element.masterContractPaymentTypeCode;
            break;
          }
        }

      }
      
      return payment;
    },
    beforeBack: function() {
      this.$store.commit('setBillsYear', this.$moment(this.$store.state.supply.invoiceDate).format('YYYY'))
    },
    goToHelp: function(code) {
      this.$store.commit('setHelp', {
        RequestTypeID: code,
        SupplyPoint: this.supplyPoint
      })
      this.$router.push('/assistenza')
    },
    goToBills: function() {
       this.$store.commit('setFromHome',false);
      this.$router.push('/bollette/' + this.$route.params.code + '/' + this.$moment(this.$store.state.supply.invoiceDate).format('YYYY') + '/' + this.supplyPoint)
    },
    goToBillsKO: function() {
      this.$store.commit('setFromHome',false);
      this.$router.push('/bollette/' + this.$route.params.code + '/' + this.$moment(this.$store.state.supply.invoiceDate).format('YYYY') + '/' + this.supplyPoint +'?paid=2')
    },
    getEvents: async function() {
      await this.axios.get(process.env.VUE_APP_API_DWH_URL + 'events?limit=' + this.limit + '&offset=' + this.offset + '&SupplyPoint=' + this.supplyPoint, this.authDWHSetting)
        .then((response) => {
          this.events.push(...response.data.results)
          this.total = response.data.total

          if (this.total <= this.events.length) {
            this.end = true
          }
        }).catch(() => {});
    },
    getDatasGraph:async function() {

        
        await this.axios.get(process.env.VUE_APP_API_DWH_URL + this.$route.params.code.toLowerCase() +'-consumptions?SupplyPoint='+this.supplyPoint, this.authDWHSetting)
        .then((response) => {
           var datas = response.data;

            var db = [];
            var tmpIndex =[];
        
            datas = datas.sort(({year:a,month:c}, {year:b,month:d}) => b-a && d-c);
            datas = datas.reverse();

            for (let index = 0; index < datas.length; index++) {
              const element = datas[index];

              tmpIndex = db.findIndex(el => el.month === element.month &&  el.year === element.year);

              if (tmpIndex > -1) {
                if (this.$route.params.code.toLowerCase() === 'ee') {
                  db[tmpIndex].f1 += element.f1;
                  db[tmpIndex].f2 += element.f2;
                  db[tmpIndex].f3 += element.f3;
                } else {
                  db[tmpIndex].smc += element.smc;
                }
                
              } else {
              db.push(element);
              }
              
            }

            
            db = db.sort(({year:a,month:c}, {year:b,month:d}) => b-a && d-c);
            
            for (let index = 0; index < db.length; index++) {
              const element = db[index];

              const month = this.$moment(element.month+'/01/'+element.year).locale("IT").format('MMM');
              const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
              
              
              

              if (this.$route.params.code.toLowerCase() === 'ee') {

                this.f1Values.push(element.f1);
                this.f2Values.push(element.f2);
                this.f3Values.push(element.f3);

                var total = (element.f1+element.f2+element.f3);

                if (total > 0) {
                  total = parseFloat(total).toLocaleString(this.$store.state.locale, { minimumFractionDigits: 3 }).replace(',00', '');
                }

                this.labels.push(total+' kWh_'+capitalizedMonth+' '+element.year);
              } else {

                var amount = element.smc;

                amount = parseFloat(amount).toLocaleString(this.$store.state.locale, { minimumFractionDigits: 3 }).replace(',00', '');

                this.labels.push((amount)+' smc_'+capitalizedMonth+' '+element.year);
                this.values.push((amount));
              }
              
            }
        }).catch(() => {});


        // var datas = this.$route.params.code.toLowerCase() === 'ee' ? [
        //   {
        //     "month": 6,
        //     "year": 2025,
        //     "f1": 1280,
        //     "f2": 300,
        //     "f3": 489
        //   },
        //   {
        //     "month": 6,
        //     "year": 2025,
        //     "f1": 280,
        //     "f2": 30,
        //     "f3": 48
        //   },
        //   {
        //     "month": 5,
        //     "year": 2025,
        //     "f1": 128,
        //     "f2": 130,
        //     "f3": 69
        //   },
        //   {
        //     "month": 4,
        //     "year": 2025,
        //     "f1": 12,
        //     "f2": 200,
        //     "f3": 1000
        //   },
        //   {
        //     "month": 3,
        //     "year": 2025,
        //     "f1": 80,
        //     "f2": 100,
        //     "f3": 189
        //   },
        //   {
        //     "month": 2,
        //     "year": 2025,
        //     "f1": 1280,
        //     "f2": 300,
        //     "f3": 489
        //   },
        //   {
        //     "month": 1,
        //     "year": 2025,
        //     "f1": 1280,
        //     "f2": 300,
        //     "f3": 489
        //   },
        //   {
        //     "month": 12,
        //     "year": 2024,
        //     "f1": 1280,
        //     "f2": 300,
        //     "f3": 489
        //   },
        //   {
        //     "month": 11,
        //     "year": 2024,
        //     "f1": 1280,
        //     "f2": 300,
        //     "f3": 489
        //   },
        //   {
        //     "month": 10,
        //     "year": 2024,
        //     "f1": 1280,
        //     "f2": 300,
        //     "f3": 489
        //   },
        //   {
        //     "month": 9,
        //     "year": 2024,
        //     "f1": 1280,
        //     "f2": 300,
        //     "f3": 489
        //   },
        //   {
        //     "month": 8,
        //     "year": 2024,
        //     "f1": 1280,
        //     "f2": 300,
        //     "f3": 489
        //   },
        //   {
        //     "month": 7,
        //     "year": 2024,
        //     "f1": 1280,
        //     "f2": 300,
        //     "f3": 489
        //   }
        // ] : [
        //       {
        //         "month": 6,
        //         "year": 2025,
        //         "smc": 100
        //       },
        //       {
        //         "month": 6,
        //         "year": 2025,
        //         "smc": 110
        //       },
        //       {
        //         "month": 5,
        //         "year": 2025,
        //         "smc": 120
        //       },
        //       {
        //         "month": 4,
        //         "year": 2025,
        //         "smc": 140
        //       },
        //       {
        //         "month": 3,
        //         "year": 2025,
        //         "smc": 170
        //       },
        //       {
        //         "month": 2,
        //         "year": 2025,
        //         "smc": 180
        //       },
        //       {
        //         "month": 1,
        //         "year": 2025,
        //         "smc": 190
        //       },
        //       {
        //         "month": 12,
        //         "year": 2024,
        //         "smc": 200
        //       },
        //       {
        //         "month": 11,
        //         "year": 2024,
        //         "smc": 98
        //       },
        //       {
        //         "month": 10,
        //         "year": 2024,
        //         "smc": 90
        //       },
        //       {
        //         "month": 9,
        //         "year": 2024,
        //         "smc": 80
        //       },
        //       {
        //         "month": 8,
        //         "year": 2024,
        //         "smc": 70
        //       },
        //       {
        //         "month": 7,
        //         "year": 2024,
        //         "smc": 63
        //       }
        //     ];
       
        
        // var db = [];
        // var tmpIndex =[];
    
        // datas = datas.sort(({year:a,month:c}, {year:b,month:d}) => b-a && d-c);
        // datas = datas.reverse();

        // for (let index = 0; index < datas.length; index++) {
        //   const element = datas[index];

        //   tmpIndex = db.findIndex(el => el.month === element.month &&  el.year === element.year);

        //   console.log(tmpIndex,'_aa_xx_datas_1');

        //   if (tmpIndex > -1) {
        //     if (this.$route.params.code.toLowerCase() === 'ee') {
        //       db[tmpIndex].f1 += element.f1;
        //       db[tmpIndex].f2 += element.f2;
        //       db[tmpIndex].f3 += element.f3;
        //     } else {
        //       db[tmpIndex].smc += element.smc;
        //     }
            
        //   } else {
        //    db.push(element);
        //   }
          
        // }

        
        // db = db.sort(({year:a,month:c}, {year:b,month:d}) => b-a && d-c);
        
        // for (let index = 0; index < db.length; index++) {
        //   const element = db[index];

        //   const month = this.$moment(element.month+'/01/'+element.year).locale("IT").format('MMM');
        //   const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
          
          
          

        //    if (this.$route.params.code.toLowerCase() === 'ee') {
        //     this.f1Values.push((element.f1));
        //     this.f2Values.push((element.f2));
        //     this.f3Values.push((element.f3));

        //     this.labels.push((element.f1+element.f2+element.f3)+' kWh_'+capitalizedMonth+' '+element.year);
        //    } else {
        //      this.labels.push((element.smc)+' smc_'+capitalizedMonth+' '+element.year);
        //       this.values.push((element.smc));
        //    }
          
        // }
    },
    getPaymentStatus: async function() {
      await this.axios.get(process.env.VUE_APP_API_DWH_URL + 'payment-status?podPdr='+this.supplyPoint, this.authDWHSetting)
        .then((response) => {
          this.paymentStatus = response.data.paymentsAreRegular ? 'ok' : 'ko'
        }).catch(() => {});
    },
    loadMore: function () {
      if (!this.end) {
        this.offset += this.limit
        this.getEvents()
      }
    }
  },
  async created() {

    this.$store.commit('setLoader', true)

    if (this.$store.state.dashboard && this.$store.state.dashboard.consumptionStatsVisible) {
      await this.getDatasGraph();
    }

    await this.getEvents();

    await this.getPaymentStatus();

    if (this.$store.state.fromHome) {
      this.activeIndex = 0;
    } else {
      this.activeIndex = 1;
    }

    this.$store.commit('setLoader', false)

  },
  beforeUnmount() {

    this.$store.commit('setFromHome', false);

    if (this.to != undefined) {
      clearInterval(this.to);
      this.to = undefined;
    }
  }
}
</script>

<style lang="scss" scoped>
.bill {
  background-color: var(--grey);

  &--invoice-ko {
      border: solid 2px red;
      color: var(--red);
  }

  &--ee {
    .bill-resume-download {
      border: solid 2px var(--ee);
      color: var(--ee);
    }

    .bill-price-total {
      color: var(--ee);
    }

    .bill-data-details-number {
      color: var(--ee);
    }
  }

  &--gas {
    .bill-resume-download {
      border: solid 2px var(--gas);
      color: var(--gas);
    }

    .bill-price-total {
      color: var(--gas);
    }

    .bill-data-details-number {
      color: var(--gas);
    }
  }

  &-header {
    padding: 35px 0;

    @include bp($md) {
      padding: 35px 0 55px;
    }

    &-code {
      opacity: 0.5;
      font-size: 12px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: normal;
      color: var(--black);
      padding-top: 20px;

      @include bp($md) {
        padding-top: 0;
        text-align: right;
      }
    }
  }

  &-resume {
    padding-bottom: 30px;

    @include bp($md) {
      padding-bottom: 70px;
    }

    &-download {
      padding: 13px 40px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: bold;
      line-height: 1;
      border: solid 2px var(--ee);
      color: var(--ee);
      text-decoration: none;
      text-transform: uppercase;
      display: inline-block;
      margin-top: 20px;

      @include bp($md) {
        margin-top: 0;
      }

      img {
        margin-right: 7px;
      }
    }

    &-head {
      img {
        width: 50px;
        margin-right: 15px;

        @include bp($md) {
          width: 70px;
        }
      }

      &-content {
        align-items: center;

        &-title {
          font-size: 16px;
          line-height: normal;
          color: var(--black);
          margin-bottom: 4px;
        }

        &-subtitle {
          font-size: 18px;
          font-weight: normal;
          line-height: normal;
          color: var(--black);

          @include bp($md) {
            font-size: 24px;
          }
        }

        &-infoinvoice {
          font-size: 16px;
          font-weight: normal;
          line-height: normal;
          color: var(--black);

        }
      }
    }
  }

  &-price {
    margin-top: 10px;

    @include bp($md) {
      margin-top: 0;
    }

    &-total {
      font-weight: bold;
      line-height: normal;
      color: var(--ee);
      font-size: 30px;

      @include bp($md) {
        font-size: 50px;
      }

      span {
        font-size: 26px;
        color: var(--black);
        display: inline-block;
        position: relative;
        left: -5px;
      }
    }

    &-expire {
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      color: var(--black);
    }
  }

  &-data {
    &-details {
      &-title {
        margin: 0 0 16px;
        opacity: 0.8;
        font-size: 12px;
        font-weight: bold;
        line-height: normal;
        text-transform: uppercase;
        color: var(--black);
      }

      &-number {
        font-size: 50px;
        font-weight: bold;
        line-height: normal;
        color: var(--ee);
        white-space: nowrap;

        span {
          font-size: 26px;
          color: var(--black);
          display: inline-block;
          position: relative;
          left: -5px;
        }
      }
    }

    &-desc {
      padding: 0 50px 0 20px;
      margin: 0 0 0 20px;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      align-items: end;

      &:before {
        content: '';
        width: 1px;
        height: 100%;
        background-color: rgba(0,0,0,.12);
        position: absolute;
        top: 0;
        left: 0;
      }

      &-indicator {
        margin: 0 0 5px;
        font-size: 22px;
        font-weight: bold;
        line-height: normal;
        color: var(--black);
        position: relative;
        width: 100%;

        &::after {
          content: '';
          display: inline-block;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 8px 7px 0 7px;
          border-color: var(--light-green) transparent transparent transparent;
          margin-left: 16px;
          position: relative;
          top: -2px;
        }

        &--red {
          &::after {
            content: '';
            display: inline-block;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 7px 8px 7px;
            border-color: transparent transparent var(--light-red) transparent;
            margin-left: 16px;
            position: relative;
            top: -2px;
          }
        }

        &--white {
          &::after {          
            border-color: transparent transparent transparent transparent;
          }
        }
      }

      &-text {
        margin: 5px 0 0;
        font-size: 12px;
        font-weight: 300;
        line-height: normal;
        color: var(--black);
        max-width: 120px;
        padding-bottom: 10px;
      }
    }
  }

  &-history {
    padding-top: 20px;
    padding-bottom: 40px;

    @include bp($md) {
      padding-top: 60px;
    }

    &-title {
      margin: 0 287px 39px 0;
      font-size: 20px;
      font-weight: normal;
      line-height: normal;
      color: var(--title-color);
    }
  }

  &-events {
    padding-top: 30px;
    padding-bottom: 60px;

    &-title {
      margin-bottom: 0;
      padding-bottom: 40px;
      font-size: 20px;
      font-weight: normal;
      line-height: normal;
      color: var(--title-color);
    }
  }
}

.manage {
  background-color: var(--grey);

  &--ee {
    .manage-block-counter {
      background-image: var(--gradient-energy-reverse);
    }
  }

  &--gas {
    .manage-block-counter {
      background-image: var(--gradient-gas);
    }
  }

  &-title {
    margin-bottom: 0;
    padding-bottom: 20px;
    padding-top: 20px;
    font-size: 20px;
    font-weight: normal;
    line-height: normal;
    color: var(--title-color);
  }

  &-block {
    padding: 20px;
    background-color: var(--white);
    height: 100%;

    &-title {
      opacity: 0.8;
      font-size: 12px;
      font-weight: bold;
      line-height: normal;
      color: var(--title-color);
      text-transform: uppercase;
    }

    &-text {
      margin: 8px 0 11px;
      font-size: 14px;
      font-weight: 300;
      font-style: normal;
      line-height: normal;
      color: var(--black);
    }

    &-counter {
      background-image: var(--gradient-ee);
      padding: 20px;
      border-radius: 4px;

      &-title {
        margin-bottom: 30px;
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        color: var(--white);

        img {
          width: 30px;
          margin-right: 10px;
        }
      }

      &-subtitle {
        margin-bottom: 8px;
        font-size: 12px;
        font-weight: 300;
        line-height: normal;
        color: var(--white);
        text-transform: uppercase;
      }

      &-text {
        font-size: 18px;
        font-weight: bold;
        line-height: normal;
        color: var(--white);
      }
    }

    &-bank {
      margin: 14px 0;
      padding: 5px 15px;
      border-radius: 4px;
      background-color: var(--grey2);
      display: flex;

      img {
        width: 30px;
        margin-right: 15px;
      }

      &-title {
        margin: 0 0 4px;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        line-height: normal;
        color: var(--black);
      }

      &-label {
        margin: 0;
        font-size: 12px;
        font-weight: bold;
        line-height: normal;
        color: var(--black);
      }
    }
  }
}
</style>